import { render, staticRenderFns } from "./salesSummaryHis.vue?vue&type=template&id=2cd1706a&scoped=true&"
import script from "./salesSummaryHis.vue?vue&type=script&lang=js&"
export * from "./salesSummaryHis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd1706a",
  null
  
)

export default component.exports